import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

// Current staff user, including the fresh permission list (roles.permissions).
// Used to refresh cached permissions without a full logout/login.
export function getProfile() {
  return apiHelper(API_URL).get('/users/profile')
}
